import { render, staticRenderFns } from "./NormalSetting.vue?vue&type=template&id=2e4652d6&scoped=true&"
import script from "./NormalSetting.vue?vue&type=script&lang=js&"
export * from "./NormalSetting.vue?vue&type=script&lang=js&"
import style0 from "./NormalSetting.vue?vue&type=style&index=0&id=2e4652d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4652d6",
  null
  
)

export default component.exports